import Api from '@/vuex/api'
import { app } from '@/main'
import {
  CLOSE_MODAL,
  CLOSE_FORM,
  CLOSE_MODAL_FORM,
  CLEAR_MODALS,
  EXPIRED_SESSION,
  GET_FORM_FIELD,
  GET_FORM_VALUE,
  LOAD_DASHBOARD,
  LOAD_FORM,
  LOAD_REPORTS,
  LOGIN,
  LOGOUT,
  LOAD_SETTINGS,
  MODIFY_FORM_VALUE,
  MODIFY_FORM_FIELD,
  OPEN_CONFIRMATION_MODAL,
  OPEN_ERROR_MODAL,
  OPEN_MODAL,
  SUBMIT_FORM,
  LOAD_STATS,
  LOAD_PENDING_CLIENT_COUNT,
  LOAD_PENDING_APPROVED_QUOTES_COUNT,
  LOAD_PENDING_MANUAL_QUOTES_COUNT,
  LOAD_PENDING_PBG_COUNT
} from '@/vuex/types'

const api = new Api()
const state = {
  loggedIn: true,
  expiredSession: false,
  modals: [],
  forms: [],
  settings: {
    pageTitle: 'Budget Vals',
    stylesheet: false
  },
  dashboard: {},
  stats: {},
  pendingClientCount: 0,
  pendingApprovedQuotesCount: 0,
  pendingManualQuotesCount: 0,
  pendingPBGCount: 0
}

const mutations = {
  [LOAD_STATS] (context, stats) {
    context.stats = { ...stats }
  },
  [OPEN_MODAL] (context, modal) {
    context.modals = [ ...context.modals, modal ]
  },
  [CLOSE_MODAL] (context, index) {
    if (index >= 0) {
      let modals = context.modals
      if (modals[index].redirect) {
        app.$router.push(modals[index].redirect, function () {}, function () {
          app.$router.push({
            path: modals[index].redirect + '?t=' + new Date().getTime()
          })
        })
        window.location.reload()
      }
      modals.splice(index, 1)
      context.modals = modals
    } else {
      throw new Error('Could not find modal to remove')
    }
  },
  [CLOSE_FORM] (context, permalink) {
    let forms = context.forms
    let _forms = []
    for (let form of forms) {
      if (form.permalink !== permalink) {
        _forms.push(form)
      }
    }
    context.forms = _forms
  },
  [CLOSE_MODAL_FORM] (context, permalink) {
    let forms = []
    let modals = []
    for (let form of context.forms) {
      if (form.permalink !== permalink) {
        forms.push(form)
      }
    }
    for (let modal of context.modals) {
      if (modal.permalink !== permalink) {
        modals.push(modal)
      }
    }
    context.modals = modals
    context.forms = forms
  },
  [CLEAR_MODALS] (context) {
    context.modals = []
  },
  [LOAD_FORM] ({ forms }, form) {
    forms.push(form)
  },
  [LOAD_DASHBOARD] (context, dashboard) {
    context.dashboard = dashboard
  },
  [LOGIN] (state) {
    state.loggedIn = true
  },
  [LOGOUT] (state) {
    state.loggedIn = false
  },
  [MODIFY_FORM_VALUE] (context, { permalink, name, value }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          forms[found].sections[j].value = value
        }
      }
      context.forms = [ ...forms ]
    }
  },
  [MODIFY_FORM_FIELD] (context, { permalink, name, field }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          forms[found].sections[j] = field
        }
      }
      context.forms = [ ...forms ]
    }
  },
  [EXPIRED_SESSION] (context, expiredSession) {
    context.expiredSession = expiredSession
  },
  [LOAD_SETTINGS] (context, settings) {
    context.settings = { ...context.settings, ...settings }
  },
  [LOAD_PENDING_CLIENT_COUNT] (context, pendingClientCount) {
    context.pendingClientCount = pendingClientCount
  },
  [LOAD_PENDING_APPROVED_QUOTES_COUNT] (context, pendingApprovedQuotesCount) {
    context.pendingApprovedQuotesCount = pendingApprovedQuotesCount
  },
  [LOAD_PENDING_MANUAL_QUOTES_COUNT] (context, pendingManualQuotesCount) {
    context.pendingManualQuotesCount = pendingManualQuotesCount
  },
  [LOAD_PENDING_PBG_COUNT] (context, pendingPBGCount) {
    context.pendingPBGCount = pendingPBGCount
  }
}

const actions = {
  async [LOAD_PENDING_CLIENT_COUNT] (context) {
    let count = await api.getPendingCount('getPendingClientCount')
    context.commit(LOAD_PENDING_CLIENT_COUNT, count)
  },
  async [LOAD_PENDING_APPROVED_QUOTES_COUNT] (context) {
    let count = await api.getPendingCount('getPendingApprovedQuotesCount')
    context.commit(LOAD_PENDING_APPROVED_QUOTES_COUNT, count)
  },
  async [LOAD_PENDING_MANUAL_QUOTES_COUNT] (context) {
    let count = await api.getPendingCount('getPendingManualQuotesCount')
    context.commit(LOAD_PENDING_MANUAL_QUOTES_COUNT, count)
  },
  async [LOAD_PENDING_PBG_COUNT] (context) {
    let count = await api.getPendingCount('getPendingPBGCount')
    context.commit(LOAD_PENDING_PBG_COUNT, count)
  },
  async [LOAD_STATS] (context, payload) {
    let stats = await api.getStats(payload)
    context.commit(LOAD_STATS, stats)
  },
  async [OPEN_MODAL] (context, modal) {
    context.commit(OPEN_MODAL, modal)
  },
  async [OPEN_ERROR_MODAL] (context, error) {
    context.commit(CLEAR_MODALS)
    let errorMessage = error ? error.data || error.message : 'Error not found'
    let errorModal = {
      title: 'Error Processing Request',
      html: '<p class="alert alert-danger">' + errorMessage + '</p>'
    }
    context.dispatch(OPEN_MODAL, errorModal)
  },
  async [OPEN_CONFIRMATION_MODAL] (context, payload) {
    context.commit(CLEAR_MODALS)
    if (payload.permalink) {
      context.commit(CLOSE_FORM, payload.permalink)
    }
    let confirmationModal = {
      title: 'Success',
      html: '<p>' + payload.confirmation + '</p>',
      dismissButtonLabel: payload.dismissButtonLabel,
      redirect: payload.redirect || false
    }
    context.dispatch(OPEN_MODAL, confirmationModal)
  },
  async [LOAD_FORM] (context, opts) {
    try {
      let form = await api.getForm(opts.permalink, opts.params, opts.auth)
      context.commit(LOAD_FORM, form)
    } catch (err) {
      throw err
    }
  },
  async [SUBMIT_FORM] (context, opts) {
    let response = {}
    try {
      response = await api.submitForm(opts.data, opts.method, opts.auth)
    } catch (err) {
      throw err
    }
    switch (opts.data.permalink) {
      case 'adminLogin':
        context.dispatch(LOGIN, response.token)
        context.commit(EXPIRED_SESSION, false)
        break
      case 'pBGRequest':
        context.dispatch(LOAD_REPORTS)
        break
      case 'acceptQuote':
        context.dispatch(LOAD_REPORTS)
        break
      case 'sendQuote':
      case 'sendPBGrQuote':
      case 'deleteQuote':
        context.dispatch(LOAD_REPORTS)
        break
    }
  },
  [LOGIN] (context, token) {
    window.sessionStorage.setItem('token', token)
    context.commit(LOGIN)
  },
  async [LOGOUT] (context) {
    context.commit(LOGOUT)
    try {
      await api.logout()
    } catch (err) {
      console.log(err)
    }
    window.sessionStorage.removeItem('token')
  },
  async [LOAD_DASHBOARD] (context, date) {
    let dashboard = await api.getDashboard(date)
    context.commit(LOAD_DASHBOARD, dashboard)
  },
  async [LOAD_SETTINGS] (context) {
    let settings = await api.loadSettings()
    context.commit(LOAD_SETTINGS, settings)
  }
}

const getters = {
  stats ({ stats }) {
    return stats
  },
  modals ({ modals }) {
    return modals
  },
  getActiveModal ({ modals }) {
    return modals.length ? modals[modals.length - 1] : false
  },
  forms ({ forms }) {
    return forms
  },
  getForm: ({ forms }) => (permalink) => {
    return forms.find(f => f.permalink === permalink)
  },
  [GET_FORM_VALUE]: ({ forms }) => ({ permalink, name }) => {
    let found = false
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          return forms[found].sections[j].value
        }
      }
    }
    return false
  },
  [GET_FORM_FIELD]: ({ forms }) => ({ permalink, name }) => {
    let found = false
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          return forms[found].sections[j]
        }
      }
    }
    return false
  },
  isLoggedIn ({ loggedIn }) {
    return loggedIn
  },
  dashboard ({ dashboard }) {
    return dashboard
  },
  expiredSession ({ expiredSession }) {
    return expiredSession
  },
  settings ({ settings }) {
    return settings
  },
  pendingClientCount ({ pendingClientCount }) {
    return pendingClientCount
  },
  pendingApprovedQuotesCount ({ pendingApprovedQuotesCount }) {
    return pendingApprovedQuotesCount
  },
  pendingManualQuotesCount ({ pendingManualQuotesCount }) {
    return pendingManualQuotesCount
  },
  pendingPBGCount ({ pendingPBGCount }) {
    return pendingPBGCount
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/application.js